import React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { useDropzone } from 'react-dropzone';
import { CButton, CCard, CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { UploadLogo } from '../actions/journey';
import { RootState } from '../../store/state';
import { JourneyConfig } from '../../shared/models/journey';
import { JOURNEY_ORG_ICON } from '../constants';
import orgLocationIcon from '../../assets/images/logo-org-new.png';

export interface OrgLocationIconFormProps extends DispatchProp {
  orgID: number;
  config: JourneyConfig;
}

const OrgLocationIconForm = (props: OrgLocationIconFormProps) => {
  const { orgID, config, dispatch } = props;

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({ accept: 'image/jpeg, image/png', maxFiles: 1 });

  const handleOnClick = (files: File[]) => () => {
    if (files.length > 0) {
      dispatch(new UploadLogo(orgID, files[0], JOURNEY_ORG_ICON, 'org-location-logo'));
    }
  };

  let logoPreviewImage = config?.theme?.orgIcon?.url;
  let dropzoneMessage = isDragActive ? 'Drop the file here' : 'Drag and drop a file here, or click to select a file';
  if (acceptedFiles.length > 0) {
    logoPreviewImage = URL.createObjectURL(acceptedFiles[0]);
    dropzoneMessage = `Current File: ${ acceptedFiles[0].name }`;
  }

  return (
    <CCard className="glympser-container--roundedWithShadow">
      <CCardHeader className='glympser-roundedTop glympser-bottomBorder'>
        Upload Organization Location Icon
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol lg="4" className="d-flex align-items-center justify-content-center">
            <img alt="company logo preview" className="header-logo-preview mb-3" src={ logoPreviewImage || orgLocationIcon } />
          </CCol>
          <CCol lg="8">
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <div { ...getRootProps({ className: 'dropzone' }) }>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <input { ...getInputProps() as any } />
              <p className='mb-0'>{ dropzoneMessage }</p>
              <em>(Only *.jpeg and *.png images will be accepted)</em>
            </div>
            <CButton className="mt-3 bg-color-orange roundedBtn" block color="info" onClick={ handleOnClick(acceptedFiles) } disabled={ acceptedFiles.length === 0 }>Upload Logo</CButton>
            <p className="mt-2 mb-0 text-center">Your image will be scaled to fit within a space of 570 pixels wide by 42 pixels tall.</p>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
}

const mapStateToProps = (state: RootState) => ({
  orgID: state?.orgHierarchy?.selectedOrg?._id,
  config: state?.journey?.config?.data,
});

export default connect(mapStateToProps)(OrgLocationIconForm);
